/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export class ReplaceGraph {
    async do(edit, context) {
        if (edit.type !== "replacegraph") {
            throw new Error(`Editor API integrity error: expected type "replacegraph", received "${edit.type}" instead.`);
        }
        // Do a full in-place replacement of the graph. Re-assigning onto context
        // won't work because the object itself is captured and used elsewhere.
        const originalUrl = context.graph.url;
        for (const key in context.graph) {
            if (Object.prototype.hasOwnProperty.call(context.graph, key)) {
                delete context.graph[key];
            }
        }
        Object.assign(context.graph, edit.replacement);
        // Ensure the URL doesn't change; it's very important.
        context.graph.url = originalUrl;
        // Also update the "mutable" graph, which is actually a bunch of caches for
        // the UI that are not automatically synchronized with the actual graph.
        context.mutable.rebuild(edit.replacement);
        return {
            success: true,
            // We don't need to include any affected things, because rebuild replaces
            // them anyway.
            affectedModules: [],
            affectedNodes: [],
            affectedGraphs: [],
        };
    }
}
//# sourceMappingURL=replace-graph.js.map